/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Платёж; отсутствует, если платёж создать не удалось
 * @export
 * @interface PayOrder200ResponseDataPayment
 */
export interface PayOrder200ResponseDataPayment {
  /**
   *
   * @type {number}
   * @memberof PayOrder200ResponseDataPayment
   */
  id: number
  /**
   *
   * @type {number}
   * @memberof PayOrder200ResponseDataPayment
   */
  orderId: number
  /**
   *
   * @type {string}
   * @memberof PayOrder200ResponseDataPayment
   */
  externalId: string
  /**
   *
   * @type {number}
   * @memberof PayOrder200ResponseDataPayment
   */
  paymentGateId: number
  /**
   *
   * @type {string}
   * @memberof PayOrder200ResponseDataPayment
   */
  uuid: string
  /**
   * Ссылка на форму оплаты платёжного шлюза
   * @type {string}
   * @memberof PayOrder200ResponseDataPayment
   */
  paymentFormUrl: string
}

/**
 * Check if a given object implements the PayOrder200ResponseDataPayment interface.
 */
export function instanceOfPayOrder200ResponseDataPayment(
  value: object
): value is PayOrder200ResponseDataPayment {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('orderId' in value) || value['orderId'] === undefined) return false
  if (!('externalId' in value) || value['externalId'] === undefined)
    return false
  if (!('paymentGateId' in value) || value['paymentGateId'] === undefined)
    return false
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('paymentFormUrl' in value) || value['paymentFormUrl'] === undefined)
    return false
  return true
}

export function PayOrder200ResponseDataPaymentFromJSON(
  json: any
): PayOrder200ResponseDataPayment {
  return PayOrder200ResponseDataPaymentFromJSONTyped(json, false)
}

export function PayOrder200ResponseDataPaymentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PayOrder200ResponseDataPayment {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    orderId: json['orderId'],
    externalId: json['externalId'],
    paymentGateId: json['paymentGateId'],
    uuid: json['uuid'],
    paymentFormUrl: json['paymentFormUrl'],
  }
}

export function PayOrder200ResponseDataPaymentToJSON(
  value?: PayOrder200ResponseDataPayment | null
): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    orderId: value['orderId'],
    externalId: value['externalId'],
    paymentGateId: value['paymentGateId'],
    uuid: value['uuid'],
    paymentFormUrl: value['paymentFormUrl'],
  }
}
